import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import SearchSiteSelect from "../../../components/comman/SiteSearchSelect";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import moment from "moment";

export default function AddMachinery() {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [siteId, setSiteId] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();

  const [pageStates, setPageStates] = useState({
    SiteData: [],
  });

  // Vendor selection states
  const [vendorId, setVendorId] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [vendorList, setVendorList] = useState([]);
  const [isLoadingVendor, setIsLoadingVendor] = useState(false);

  // Purchased By selection states
  const [purchasedById, setPurchasedById] = useState("");
  const [purchasedByName, setPurchasedByName] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [isLoadingEmployee, setIsLoadingEmployee] = useState(false);

  const isEdit = !!location?.state?.EditData;

  useEffect(() => {
    if (userDetails?.type === 2) {
      GetSiteList();
    } else {
      const formattedSites = userDetails?.usersites?.map((item) => ({
        value: item?.site?.id || item?.siteId,
        label: item?.site?.name || "",
      })) || [];
      setPageStates((prevStates) => ({
        ...prevStates,
        SiteData: formattedSites,
      }));
    }
    GetVendorList();
    GetEmployeeList();
  }, []);

  useEffect(() => {
    const editData = location?.state?.EditData;
    if (editData) {
      setSiteId(editData.siteId || "");
      setVendorId(editData.vendorId || "");
      setPurchasedById(editData.purchasedById || "");

      setVendorName(editData.Vendor?.firmName || "");
      const pName = editData.purchasedBy?.name || editData.user?.name || "";
      setPurchasedByName(pName);

      reset({
        name: editData.name || "",
        machineNumber: editData.machineNumber || "",
        fuelType: editData.fuelType || "",
        readingType: editData.readingType || "",
        chesisNumber: editData.chesisNumber || "",
        engineNumber: editData.engineNumber || "",
        model: editData.model || "",
        make: editData.make || "",
        assetNo: editData.assetNo || "",
        type: editData.type || "",
        year: editData.year || "",
        purchaseCost: editData.purchaseCost || "",
        purchaseDate: editData.purchaseDate ? moment(editData.purchaseDate).format("YYYY-MM-DD") : "",
        poNumber: editData.poNumber || "",
        ptNumber: editData.ptNumber || "",
        firstServiceAt: editData.firstServiceAt || "",
        icon: editData.icon || "",
      });
    }
  }, [location]);

  const GetSiteList = (search) => {
    let options = { method: "GET" };
    let API = apiUrl.get_site + `${search ? `?search=${search}` : ""}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        const formattedData = response.data?.site.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          SiteData: formattedData,
        }));
      }
    });
  };

  const GetVendorList = (search) => {
    setIsLoadingVendor(true);
    let options = { method: "GET" };
    let API = apiUrl.get_vendor + `${search ? `?search=${search}` : ""}`;
    callApi(API, options).then((response) => {
      setIsLoadingVendor(false);
      if (response?.status === true) {
        const formattedData = response.data?.vendor.map((item) => ({
          value: item.id,
          label: item.firmName,
        }));
        setVendorList(formattedData);
        const editData = location?.state?.EditData;
        if (editData?.vendorId) {
          const match = formattedData.find((v) => v.value === editData.vendorId);
          if (match) setVendorName(match.label);
        }
      }
    });
  };

  const GetEmployeeList = (search) => {
    setIsLoadingEmployee(true);
    let options = { method: "GET" };
    let API = apiUrl.get_employee + `?status=current${search ? `&search=${search}` : ""}`;
    callApi(API, options).then((response) => {
      setIsLoadingEmployee(false);
      if (response?.status === true) {
        const formattedData = response.data?.user.map((item) => ({
          value: item.id,
          label: item.name || `${item.firstName || ""} ${item.lastName || ""}`.trim() || "--",
        }));
        setEmployeeList(formattedData);
        const editData = location?.state?.EditData;
        if (editData?.purchasedById) {
          const match = formattedData.find((e) => e.value === editData.purchasedById);
          if (match) setPurchasedByName(match.label);
        }
      }
    });
  };

  const onSubmit = (data) => {
    if (!siteId) {
      setError("Site is required");
      return;
    }
    const option = {
      method: "POST",
      data: {
        ...data,
        siteId,
        vendorId: vendorId || null,
        purchasedById: purchasedById || null,
        year: data.year ? Number(data.year) : null,
        purchaseCost: data.purchaseCost ? Number(data.purchaseCost) : null,
        firstServiceAt: data.firstServiceAt ? Number(data.firstServiceAt) : null,
      },
    };
    setIsLoading(true);
    const endPoint = isEdit
      ? apiUrl.update_machinery + `?machineryId=${location?.state?.EditData?.id}`
      : apiUrl.add_machinery;
    callApi(endPoint, option).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        navigate(-1);
        toast.success(res?.message);
      } else {
        toast.error(res?.message);
      }
    });
  };

  return (
    <div className="content container-fluid">
      {/* ── Page Header ── */}
      <div className="content-head mb-4 d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-3">
          <button onClick={() => navigate(-1)} className="btn back-arrow">
            <BackArrowIcon />
          </button>
          <div>
            <h1 className="mb-0">{isEdit ? "Update" : "Add"} Machinery</h1>
            <p className="text-muted mb-0 fs-6">
              {isEdit ? "Edit machinery details" : "Register a new machinery asset to the system"}
            </p>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* ── Section 1: Basic Info ── */}
        <div className="card mb-4">
          <div className="card-header bg-transparent border-bottom py-3 d-flex align-items-center gap-2">
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #f59e0b, #d97706)",
                display: "inline-block",
                flexShrink: 0,
              }}
            />
            <h5 className="mb-0 fw-semibold">Basic Information</h5>
          </div>
          <div className="card-body py-4">
            <div className="row g-3">
              {/* Site */}
              <div className="col-12 col-md-6 col-lg-4">
                <SearchSiteSelect
                  label="Site"
                  required
                  value={siteId}
                  options={pageStates.SiteData}
                  onSelect={(opt) => {
                    setSiteId(opt?.value);
                    setError(opt?.value ? "" : "Site is required");
                  }}
                  onSearch={(q) => GetSiteList(q)}
                  isLoading={pageStates.isLoadingSite}
                  placeholder="Search Site"
                  errors={error}
                  className="ps-5"
                />
              </div>

              {/* Machine Name */}
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">
                  Machine Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  id="machineName"
                  placeholder="e.g. JCB 3DX Backhoe"
                  {...register("name", { required: "This field is required" })}
                />
                {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
              </div>

              {/* Type */}
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">
                  Type <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${errors.type ? "is-invalid" : ""}`}
                  {...register("type", { required: "This field is required" })}
                >
                  <option value="">Select Type</option>
                  <option value="Machine">🔧 Machine</option>
                  <option value="Vehicle">🚛 Vehicle</option>
                </select>
                {errors.type && <ErrorMessage message={errors.type.message} />}
              </div>

              {/* Asset Number */}
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Asset Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="assetNo"
                  placeholder="e.g. MCH-001"
                  {...register("assetNo")}
                />
              </div>

              {/* Machine Number */}
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Machine Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="machineNumber"
                  placeholder="Machine registration number"
                  {...register("machineNumber")}
                />
              </div>

              {/* Reading Type */}
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">
                  Reading Type <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${errors.readingType ? "is-invalid" : ""}`}
                  {...register("readingType", { required: "This field is required" })}
                >
                  <option value="">Select Reading Type</option>
                  <option value="hours">⏱ Hours</option>
                  <option value="km">📍 Kilometres</option>
                </select>
                {errors.readingType && <ErrorMessage message={errors.readingType.message} />}
              </div>

              {/* Fuel Type */}
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">
                  Fuel Type <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${errors.fuelType ? "is-invalid" : ""}`}
                  {...register("fuelType", { required: "This field is required" })}
                >
                  <option value="">Select Fuel Type</option>
                  <option value="Petrol">⛽ Petrol</option>
                  <option value="Diesel">🛢 Diesel</option>
                  <option value="Electric">⚡ Electric</option>
                  <option value="CNG">🔵 CNG</option>
                </select>
                {errors.fuelType && <ErrorMessage message={errors.fuelType.message} />}
              </div>

              {/* First Service At */}
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">First Service At (Hours/Kms)</label>
                <input
                  type="number"
                  className="form-control"
                  id="firstServiceAt"
                  placeholder="e.g. 1500"
                  {...register("firstServiceAt")}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── Section 2: Technical Specifications ── */}
        <div className="card mb-4">
          <div className="card-header bg-transparent border-bottom py-3 d-flex align-items-center gap-2">
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #048604, #6366f1)",
                display: "inline-block",
                flexShrink: 0,
              }}
            />
            <h5 className="mb-0 fw-semibold">Technical Specifications</h5>
          </div>
          <div className="card-body py-4">
            <div className="row g-3">
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Make</label>
                <input
                  type="text"
                  className="form-control"
                  id="make"
                  placeholder="e.g. JCB, Caterpillar"
                  {...register("make")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Model</label>
                <input
                  type="text"
                  className="form-control"
                  id="model"
                  placeholder="e.g. 3DX"
                  {...register("model")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Model Year</label>
                <input
                  type="number"
                  className="form-control"
                  id="year"
                  placeholder="e.g. 2024"
                  {...register("year")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Chassis Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="chesisNumber"
                  placeholder="Chassis number"
                  {...register("chesisNumber")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Engine Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="engineNumber"
                  placeholder="Engine number"
                  {...register("engineNumber")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Icon Name / URL</label>
                <input
                  type="text"
                  className="form-control"
                  id="icon"
                  placeholder="Icon name or image url"
                  {...register("icon")}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── Section 3: Purchase Details ── */}
        <div className="card mb-4">
          <div className="card-header bg-transparent border-bottom py-3 d-flex align-items-center gap-2">
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #10b981, #059669)",
                display: "inline-block",
                flexShrink: 0,
              }}
            />
            <h5 className="mb-0 fw-semibold">Purchase Details</h5>
          </div>
          <div className="card-body py-4">
            <div className="row g-3">
              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Purchase Cost (₹)</label>
                <input
                  type="number"
                  className="form-control"
                  id="purchaseCost"
                  placeholder="e.g. 2800000"
                  {...register("purchaseCost")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">Purchase Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="purchaseDate"
                  {...register("purchaseDate")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">PO Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="poNumber"
                  placeholder="e.g. PO-2024-001"
                  {...register("poNumber")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label className="form-label fw-medium">PT Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="ptNumber"
                  placeholder="e.g. PT-XXXX-XXX"
                  {...register("ptNumber")}
                />
              </div>

              {/* Vendor */}
              <div className="col-12 col-md-6 col-lg-4">
                <SearchSelectInput
                  label="Vendor"
                  placeholder="Search Vendor"
                  value={vendorName}
                  onSelect={(option) => {
                    setVendorId(option?.value || "");
                    setVendorName(option?.label || "");
                  }}
                  options={vendorList}
                  onSearch={(search) => GetVendorList(search)}
                  isLoading={isLoadingVendor}
                  showAddButton={false}
                  required={false}
                />
              </div>

              {/* Purchased By */}
              <div className="col-12 col-md-6 col-lg-4">
                <SearchSelectInput
                  label="Purchased By"
                  placeholder="Search Employee"
                  value={purchasedByName}
                  onSelect={(option) => {
                    setPurchasedById(option?.value || "");
                    setPurchasedByName(option?.label || "");
                  }}
                  options={employeeList}
                  onSearch={(search) => GetEmployeeList(search)}
                  isLoading={isLoadingEmployee}
                  showAddButton={false}
                  required={false}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── Submit ── */}
        <div className="d-flex align-items-center justify-content-end gap-3 mb-5">
          <button
            type="button"
            className="btn btn-outline-secondary px-4"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
          <button className="btn btn-primary px-5" type="submit" disabled={isLoading}>
            {isLoading ? (
              <><Spinner size="sm" className="me-2" />{isEdit ? "Updating..." : "Saving..."}</>
            ) : (
              isEdit ? "Update Machinery" : "Add Machinery"
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
